import React from 'react';
import { Link } from 'react-router';
import MainFooter from '../components/common/footer/MainFooter';
import '../stylesheets/core.less';

const Credits = () => (
  <div className="photo-credits">
    <header className="row top-bar margin-top">
      <div className="col-xs-4 col-xs-push-4 col-sm-push-4 col-md-push-4 col-lg-push-4">
        <Link to="/wedding-planning">
          <div className="zola-weddings-logo-black-120 center-block margin-bottom margin-top" />
        </Link>
      </div>
    </header>
    <div className="container">
      <h1>Website Design & Photography Credits</h1>
      <ul className="list-unstyled">
        <li>
          <p>
            Design Name: Abbey
            <br />
            Main Photograph By: <a href="http://rebeccayalephotography.com/" target="_blank" rel="noopener noreferrer">Rebecca Yale</a>
          </p>
        </li>
        <li>
          <p>
            Design Name: Sparrow
            <br />
            Main Photograph By: <a href="http://lesleemitchell.com/" target="_blank" rel="noopener noreferrer">Leslee Mitchell</a>
          </p>
        </li>
        <li>
          <p>
            Design Name: Eastwick
            <br />
            Main Photograph By: <a href="http://rebeccayalephotography.com/" target="_blank" rel="noopener noreferrer">Rebecca Yale</a>
          </p>
        </li>
        <li>
          <p>
            Design Name: Wrightsville
            <br />
            Main Photograph By: <a href="http://valoriedarlingphotography.com/" target="_blank" rel="noopener noreferrer">Valorie Darling</a>
          </p>
        </li>
        <li>
          <p>
            Design Name: Escape
            <br />
            Main Photograph By: <a href="http://rebeccayalephotography.com/" target="_blank" rel="noopener noreferrer">Rebecca Yale</a>
          </p>
        </li>
        <li>
          <p>
            Design Name: Paros
            <br />
            Main Photograph By: <a href="http://jennemerlingweddings.com/" target="_blank" rel="noopener noreferrer">Jenn Emerling</a>
          </p>
        </li>
      </ul>
    </div>
    <MainFooter />
  </div>
);

export default Credits;



// WEBPACK FOOTER //
// ./src/components/Credits.jsx